<header class="form__header">
  <h4 class="form__title">{{ config.form.title }}</h4>
  @if (config.form.description && !isEmailSent) {
    <p class="form__description" [innerHTML]="config.form.description"></p>
  }
</header>

@if (!isEmailSent) {
  <form-group
    class="form__controls"
    [form]="form"
    [configs]="config.form.controls"
    direction="filter"
  >
  </form-group>
} @else {
  <p class="t-html" [innerHtml]="config.resend_confirmation"></p>
}

<footer class="form__footer">
  <div class="u-flex u-alignCenter">
    <a
      class="form__link"
      [routerLink]="'/auth/login'"
      [innerHTML]="authService.configuration.login.form.title"
    ></a>
    <a
      class="form__link"
      [routerLink]="'/auth/registration'"
      [innerHTML]="authService.configuration.registration.form.title"
    ></a>
  </div>

  @if (!isEmailSent) {
    <zip-button [config]="config.submit" (zipButtonClicked)="submit()">
    </zip-button>
  }
</footer>
